import { MEDIA_URL } from '../api/url';

export const getImagePath = ({ path, uid, extension }) => `${MEDIA_URL + path}/${uid}${extension}`;
